export default "__VITE_ASSET__DIcD1XEl__"